if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitting || this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.submitting = true;
      let itemAdded = false;
      let navigating = false;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.setAttribute('aria-busy', true);
      this.submitButton.classList.add('loading');
      const spinner = this.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json().then((data) => {
          if (!response.ok && !data.status) data.status = response.status;
          return data;
        }))
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description || response.message || window.cartStrings.error);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            const buttonLabel = this.submitButton.querySelector('span:not(.sold-out-message)');
            if (buttonLabel) buttonLabel.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            navigating = true;
            window.location = window.routes.cart_url;
            return;
          }

          itemAdded = true;
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            return new Promise((resolve, reject) => {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => {
                  Promise.resolve().then(() => this.cart.renderContents(response)).then(resolve, reject);
                });
              }, { once: true });
              quickAddModal.hide(true);
            });
          } else {
            return this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
          if (itemAdded) {
            // The cart mutation succeeded. Show its authoritative page instead
            // of inviting another add when only the drawer refresh failed.
            navigating = true;
            window.location.assign(window.routes.cart_url);
            return;
          }
          this.handleErrorMessage(window.cartStrings.error);
        })
        .finally(() => {
          if (navigating) return;
          this.submitting = false;
          this.submitButton.removeAttribute('aria-busy');
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
